(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initParallax(root) {
    var stage = root.querySelector('[data-sch-parallax-stage]') || root;
    var track = root.querySelector('[data-sch-parallax-track]');
    var marquee = root.querySelector('[data-sch-parallax-marquee]');
    var panel = root.querySelector('[data-sch-parallax-panel]');

    if (!track) {
      return;
    }

    if (reducedMotion.matches) {
      track.style.transform = 'none';
      if (marquee) {
        marquee.style.transform = 'none';
      }
      if (panel) {
        panel.classList.add('is-revealed');
      }
      return;
    }

    var target = 0;
    var current = 0;
    var revealThreshold = 40;
    var touchStartX = null;
    var touchStartY = null;

    function removeRevealListeners() {
      window.removeEventListener('scroll', handleRevealScroll);
      root.removeEventListener('touchstart', handleRevealTouchStart);
      root.removeEventListener('touchmove', handleRevealTouchMove);
    }

    function revealPanel(immediately) {
      if (!panel || panel.classList.contains('is-revealed')) {
        removeRevealListeners();
        return;
      }

      if (immediately) {
        panel.style.transition = 'none';
      }
      panel.classList.add('is-revealed');
      if (immediately) {
        panel.getBoundingClientRect();
        panel.style.transition = '';
      }
      removeRevealListeners();
    }

    function handleRevealScroll() {
      if (window.scrollY > revealThreshold) {
        revealPanel(false);
      }
    }

    function handleRevealTouchStart(event) {
      if (event.touches.length === 0) {
        return;
      }
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }

    function handleRevealTouchMove(event) {
      if (event.touches.length === 0 || touchStartX === null || touchStartY === null) {
        return;
      }

      var dx = event.touches[0].clientX - touchStartX;
      var dy = event.touches[0].clientY - touchStartY;
      if (Math.sqrt(dx * dx + dy * dy) > revealThreshold) {
        revealPanel(false);
      }
    }

    if (panel) {
      if (window.scrollY > revealThreshold) {
        revealPanel(true);
      } else {
        window.addEventListener('scroll', handleRevealScroll, { passive: true });
        root.addEventListener('touchstart', handleRevealTouchStart, { passive: true });
        root.addEventListener('touchmove', handleRevealTouchMove, { passive: true });
      }
    }

    function updateTarget(clientX) {
      var bounds = stage.getBoundingClientRect();
      var max = Math.max(track.scrollWidth - bounds.width, 0);
      if (max === 0 || bounds.width === 0) {
        target = 0;
        return;
      }

      var ratio = Math.min(Math.max((clientX - bounds.left) / bounds.width, 0), 1);
      target = -ratio * max;
    }

    if ('ontouchstart' in window || window.matchMedia('(pointer: coarse)').matches) {
      root.addEventListener('touchmove', function (event) {
        if (event.touches.length > 0) {
          updateTarget(event.touches[0].clientX);
        }
      }, { passive: true });
    } else {
      root.addEventListener('mousemove', function (event) {
        updateTarget(event.clientX);
      });
    }

    function loop() {
      current += (target - current) * 0.05;
      track.style.transform = 'translateX(' + current.toFixed(2) + 'px)';
      if (marquee) {
        marquee.style.transform = 'translateX(' + (current * 1.15).toFixed(2) + 'px)';
      }
      window.requestAnimationFrame(loop);
    }

    loop();
  }

  function init() {
    document.querySelectorAll('[data-sch-parallax]').forEach(initParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
